import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { IdentityService } from '../authentication/identity.service';
import { NotificationsService } from '../notifications/notifications.service';
import {
  RegisterODNUserCommand,
  IRegisterODNUserParameters
} from './command/registerODNUser.command';
import {
  DeleteODNUserCommand,
  IDeleteODNUserParameters
} from './command/deleteODNUser.command';
import {
  RequestRegisterODNUserCommand,
  IRequestRegisterODNUserParameters
} from './command/requestRegisterODNUser.command';
import {
  RegisterAuthorizeNetCommand,
  IRegisterAuthorizeNetParameters
} from './command/registerAuthorizeNet.command';
import {
  UnlinkAuthorizeNetCommand,
  IUnlinkAuthorizeNetParameters
} from './command/unlinkAuthorizeNet.command';
import {
  RegisterEBizChargeCommand,
  IRegisterEBizChargeParameters
} from './command/registerEBizCharge.command';
import {
  UnlinkEBizChargeCommand,
  IUnlinkEBizChargeParameters
} from './command/unlinkEBizCharge.command';

export interface CreateODNUserDTO {
  password: string;
  userCode: string;
  userName: string;
}

export interface NewGnetUserDTO {
  contact: string;
  phone: string;
  email: string;
  companyAddress: string;
  webUrl: string;
  company: string;
}

export interface IRegisterAuthorizeNetDTO {
  apiLoginId: string;
  transactionKey: string;
}

export interface IRegisterEBizChargeDTO {
  subscriptionKey: string;
  securityId: string;
  ebizUserId: string;
  pass: string;
}

@Injectable()
export class ODNService {
  private titleMessage = 'toast.integrations.title';

  constructor(
    private _connectionService: ConnectionServices,
    private _identityService: IdentityService,
    private _notificationsService: NotificationsService
  ) {}

  public registerGnetUser(data: CreateODNUserDTO): Observable<boolean> {
    const command = new RegisterODNUserCommand();
    command.setParameters(<IRegisterODNUserParameters>{
      carrierId: this._identityService.userId,
      password: data.password,
      userCode: data.userCode,
      userName: data.userName,
      userId: parseInt(this._identityService.subUserId),
      odnCode: 'GNET'
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public deleteGnetUser(): Observable<boolean> {
    const command = new DeleteODNUserCommand();
    command.setParameters(<IDeleteODNUserParameters>{
      carrierId: this._identityService.userId,
      userId: parseInt(this._identityService.subUserId),
      odnCode: 'GNET'
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public createGnetUser(data: NewGnetUserDTO): Observable<boolean> {
    const command = new RequestRegisterODNUserCommand();
    command.setParameters(<IRequestRegisterODNUserParameters>{
      carrierId: this._identityService.userId,
      contact: data.contact,
      phone: data.phone,
      email: data.email,
      companyAddress: data.companyAddress,
      webUrl: data.webUrl,
      company: data.company,
      userId: parseInt(this._identityService.subUserId),
      odnCode: 'GNET'
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public registerAuthorizeNet(data: IRegisterAuthorizeNetDTO): Observable<boolean> {
    const command = new RegisterAuthorizeNetCommand();
    command.setParameters(<IRegisterAuthorizeNetParameters>{
      apiLoginId: data.apiLoginId,
      transactionKey: data.transactionKey,
      userId: parseInt(this._identityService.subUserId)
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public unlinkAuthorizeNet(appId: number): Observable<boolean> {
    const command = new UnlinkAuthorizeNetCommand();
    command.setParameters(<IUnlinkAuthorizeNetParameters>{
      userId: parseInt(this._identityService.subUserId),
      appId
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public registerEBizCharge(data: IRegisterEBizChargeDTO): Observable<boolean> {
    const command = new RegisterEBizChargeCommand();
    command.setParameters(<IRegisterEBizChargeParameters>{
      subscriptionKey: data.subscriptionKey,
      securityId: data.securityId,
      ebizUserId: data.ebizUserId,
      pass: data.pass,
      userId: parseInt(this._identityService.subUserId)
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public unlinkEBizCharge(appId: number): Observable<boolean> {
    const command = new UnlinkEBizChargeCommand();
    command.setParameters(<IUnlinkEBizChargeParameters>{
      userId: parseInt(this._identityService.subUserId),
      appId
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }
}
